import React, { useMemo } from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { DialogClose, DialogFooter } from '@/components/ui/dialog';
import { Form as ShadcnForm } from '@/components/ui/form';
import { Alert } from '../../../../../../shared/components/Alert';
import {
  InputField,
  SelectField,
  SubmitButton,
  TextareaField,
} from '../../../../../../shared/components/Form';
import { useAuth } from '../../../../../../shared/hooks';
import { peopleOptions } from '../../../../../../shared/utils';
import { formShape } from '../../../../../shared/types';
import { ERROR_TITLES } from '../../../constants';
import { useCalendar } from '../../../hooks';
import { appointmentShape } from '../../../types';

const Form = ({ activeAppointment, errorMessage, form, isSubmitting, onSubmit }) => {
  const {
    user: { id: currentUserId },
  } = useAuth();

  const { isLoading, users } = useCalendar();

  const alertTitle = activeAppointment
    ? ERROR_TITLES.appointment.update
    : ERROR_TITLES.appointment.create;

  const userOptions = useMemo(
    () => peopleOptions({ currentUserId, users }),
    [users, currentUserId]
  );

  return (
    <ShadcnForm {...form}>
      <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)}>
        <InputField
          control={form.control}
          label="Title"
          name="title"
          placeholder="Enter a title for the appointment"
        />

        <TextareaField
          control={form.control}
          label="Description"
          name="description"
          placeholder="Enter a description for the appointment"
        />

        <SelectField
          control={form.control}
          disabled={isLoading}
          label="User"
          name="userId"
          options={userOptions}
          placeholder="Select a user"
        />

        {/* TODO: Add fields for Task and Clients. */}

        <InputField
          control={form.control}
          label="Start"
          name="startAt"
          type="datetime-local"
        />

        <InputField
          control={form.control}
          label="End"
          name="endAt"
          type="datetime-local"
        />

        {!isEmpty(errorMessage) && (
          <Alert
            description={errorMessage}
            icon={<FontAwesomeIcon icon={faCircleExclamation} />}
            title={alertTitle}
            variant="destructive"
          />
        )}

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>

          <SubmitButton isLoading={isSubmitting}>Save</SubmitButton>
        </DialogFooter>
      </form>
    </ShadcnForm>
  );
};

Form.propTypes = {
  activeAppointment: PropTypes.oneOfType([appointmentShape, null]).isRequired,
  errorMessage: PropTypes.string.isRequired,
  form: formShape.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
